import script from "./App.vue?vue&type=script&lang=tsx"
export * from "./App.vue?vue&type=script&lang=tsx"

const __exports__ = script;

export default __exports__